<template>
  <div id="contact-page" class="min-vh-100 d-flex flex-column">
    <loading-component-s2 v-if="isLoading" />

    <main class="flex-grow-1 bg-light">
      <!-- Banner -->
      <div
        class="contact-banner text-white py-5"
        style="background: linear-gradient(to right, #0d0d0d, rgba(13, 13, 13, 0.8));"
      >
        <div class="container oversized-container px-4">
          <h1 class="font-weight-bold mb-4 contact-title">Get in Touch</h1>
          <p class="lead mb-0" style="max-width: 36rem; opacity: 0.9;">
            Have questions about our diesel engine components? Our team is here to help you find the right parts.
          </p>
        </div>
      </div>

      <div class="container oversized-container px-4 py-5" style="max-width: 56rem;">
        <div class="row">
          <!-- Contact Form -->
          <div class="col-12 col-md-6 mb-5 mb-md-0" v-if="!messageSent">
            <h2 class="h4 font-weight-bold mb-4">Send us a Message</h2>
            <form @submit.prevent="onSubmit">
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="firstName" class="font-weight-bold mb-2 small">
                    First Name *
                  </label>
                  <input
                    id="firstName"
                    type="text"
                    class="form-control"
                    placeholder="John"
                    maxlength="170"
                    required
                    v-model="form.name"
                  >
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="lastName" class="font-weight-bold mb-2 small">
                    Last Name *
                  </label>
                  <input
                    id="lastName"
                    type="text"
                    class="form-control"
                    placeholder="Doe"
                    maxlength="170"
                    required
                    v-model="form.lastname"
                  >
                </div>
              </div>

              <div class="form-group">
                <label for="email" class="font-weight-bold mb-2 small">
                  Email Address *
                </label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  placeholder="john@example.com"
                  required
                  v-model="form.email"
                >
              </div>

              <div class="form-group">
                <label for="phone" class="font-weight-bold mb-2 small">
                  Phone Number
                </label>
                <input
                  id="phone"
                  type="tel"
                  class="form-control"
                  placeholder="+1 (555) 000-0000"
                  v-model="form.phone"
                  maxlength="10"
                >
              </div>

              <div class="form-group">
                <label for="subject" class="font-weight-bold mb-2 small">
                  Subject *
                </label>
                <input
                  id="subject"
                  type="text"
                  class="form-control"
                  placeholder="Part inquiry, technical support, etc."
                  required
                  v-model="form.subject"
                  maxlength="190"
                >
              </div>

              <div class="form-group">
                <label for="message" class="font-weight-bold mb-2 small">
                  Message *
                </label>
                <textarea
                  id="message"
                  class="form-control"
                  rows="6"
                  placeholder="Tell us how we can help you..."
                  required
                  v-model="form.msg"
                  maxlength="1000"
                ></textarea>
              </div>

              <button type="submit" class="btn btn-accent btn-block font-weight-bold" :disabled="disabledButton">
                Send Message
              </button>
            </form>
          </div>

          <div class="col-12 col-md-6 mb-5 mb-md-0 text-center py-5 mt-5" v-if="messageSent">
            <i class="fa-regular fa-circle-check mb-2" style="font-size: 3.5rem;"></i>

            <h3 class="h4 font-weight-bold mb-4 h1">Message sent successfully</h3>
            <h5 class="text-muted mb-0">
              Thank you for your message.<br />
              We will contact you as soon as possible.
            </h5>
          </div>

          <!-- Contact Information -->
          <div class="col-12 col-md-6">
            <h2 class="h4 font-weight-bold mb-4">Contact Information</h2>
            <div class="mb-4">
              <div class="card border mb-3 contact-info-card">
                <div class="card-body p-4">
                  <div class="d-flex align-items-start">
                    <div class="contact-info-icon-wrapper mr-3">
                      <i class="fa-solid fa-phone txt-cprimary"></i>
                    </div>
                    <div>
                      <h3 class="h6 font-weight-bold mb-2">Phone</h3>
                      <p class="text-muted mb-1 small">1-800-DEC-PARTS</p>
                      <p class="text-muted mb-0 small">+1 (323) 555-0100</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card border mb-3 contact-info-card">
                <div class="card-body p-4">
                  <div class="d-flex align-items-start">
                    <div class="contact-info-icon-wrapper mr-3">
                      <i class="fa-solid fa-envelope txt-cprimary"></i>
                    </div>
                    <div>
                      <h3 class="h6 font-weight-bold mb-2">Email</h3>
                      <p class="text-muted mb-1 small">info@decindustries.com</p>
                      <p class="text-muted mb-0 small">info@decindustries.us</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card border mb-3 contact-info-card">
                <div class="card-body p-4">
                  <div class="d-flex align-items-start">
                    <div class="contact-info-icon-wrapper mr-3">
                      <i class="fa-solid fa-location-dot txt-cprimary"></i>
                    </div>
                    <div>
                      <h3 class="h6 font-weight-bold mb-2">Address</h3>
                      <p class="text-muted mb-1 small">1601 Vine St</p>
                      <p class="text-muted mb-1 small">Los Angeles, CA 90028</p>
                      <p class="text-muted mb-0 small">United States</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card border mb-3 contact-info-card">
                <div class="card-body p-4">
                  <div class="d-flex align-items-start">
                    <div class="contact-info-icon-wrapper mr-3">
                      <i class="fa-solid fa-clock txt-cprimary"></i>
                    </div>
                    <div>
                      <h3 class="h6 font-weight-bold mb-2">Business Hours</h3>
                      <p class="text-muted mb-1 small">Monday - Friday: 8:00 AM - 6:00 PM EST</p>
                      <p class="text-muted mb-1 small">Saturday: 9:00 AM - 2:00 PM EST</p>
                      <p class="text-muted mb-0 small">Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Quick Support -->
            <!-- <div class="card border contact-whatsapp-card">
              <div class="card-body p-4">
                <h3 class="h6 font-weight-bold mb-2">Need Immediate Assistance?</h3>
                <p class="text-muted small mb-4">
                  Chat with us on WhatsApp for quick responses to urgent inquiries.
                </p>
                <a
                  href="#"
                  class="btn btn-block text-white font-weight-bold"
                  style="background-color: #25D366;"
                  @click.prevent="contactWhatsApp"
                >
                  <i class="fa-brands fa-whatsapp mr-2"></i>
                  Contact on WhatsApp
                </a>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      disabledButton: false,
      messageSent: false,

      form: {
        name: '',
        lastname: '',
        email: '',
        phone: '',
        subject: '',
        msg: '',
      },
    };
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-left',
        appendToast: true
      })
    },

    onSubmit(event) {
      // Handle form submission - add your API call or logic here
      event.preventDefault();
      this.disabledButton = true;
      this.isLoading = true;

      axios.post('/api/contact', this.form).then(response => {
        this.makeToast('success', response.data.response, 'Message sent successfully');
        this.form = {
          name: '',
          lastname: '',
          email: '',
          phone: '',
          subject: '',
          msg: '',
        };
        this.disabledButton = false;
        this.isLoading = false;
        this.messageSent = true;
      }).catch(error => {
        // console.log(errors);
        let errors = error.response.data;
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.lastname, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.subject, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
        this.disabledButton = false;
        this.isLoading = false;
      });
    },

    contactWhatsApp() {
      // Add WhatsApp link - replace with your actual number
      window.open('https://wa.me/13235550100', '_blank');
    },
  },
};
</script>
